import { NOTIFICATION_EVENT_TYPE } from "./constants";

export enum NotificationEventCategory {
  ACTIVITY = "activity",
  SUPPORT = "support",
  RESPONSE = "response",
  TECHNICAL_ISSUES = "technical_issues",
  ORG = "org",
}

export interface Notification {
  id: string;
  heading?: string;
  description?: string;
  lead_id?: string;
  lead_type?: string;
  name?: string;
  channel?: string;
  cta: DashboardEventCTA;
  event_category_v2: NotificationEventCategory;
  event_type: NOTIFICATION_EVENT_TYPE;
  created_at: string;
  client_name?: string;
  client_logo_url?: string;
  priority: string;
  scope: "org" | "client";
  client_code?: string;
  is_read: boolean;
  miscellaneous_data: Record<string, string>;
}

export enum DashboardEventCTAEventType {
  CRM = "crm",
  COMMUNICATIONS = "communications",
  CAMPAIGN_COMMUNICATIONS = "campaign_communications",
  HELPDESK = "helpdesk",
}

export interface DashboardEventCTAParameters {
  lead_id?: string;
  client_code?: string;
  channel?: string;
  message_id?: string;
  campaign_id?: string;
}

export interface DashboardEventCTA {
  link: string;
  text: string;
  cta_type?: DashboardEventCTAEventType;
  parameters?: DashboardEventCTAParameters;
}

export interface NotificationItemProps {
  notification: Notification;
  activeTab: NotificationEventCategory;
}

export interface NotificationAPIResponse {
  unread_events_count: {
    [key in NotificationEventCategory]: number;
  };
  events: Notification[];
  total_events_count: {
    [key in NotificationEventCategory]: number;
  };
  has_more: boolean;
  next_cursor: string | null;
}
